import EventCard from '/react4xp/components/prototype/EventCard'
import NoEventsBox from '/react4xp/components/prototype/NoEventsBox'
import Pagination from '/react4xp/components/prototype/Pagination'
import SubpageHero from '/react4xp/components/prototype/SubpageHero'

import type { EventListProps } from './types'

export default function EventList({
	overline,
	heading,
	locationFilter,
	dateFilter,
	events,
	currentPage = 1,
	totalPages,
	onPageChange,
	noEventsBox,
}: EventListProps) {
	const showNoEventsBox = dateFilter.value === 'upcoming' && events.length === 0

	return (
		<>
			<SubpageHero overline={overline} heading={heading} filters={[locationFilter, dateFilter]} />

			<section className="my-12">
				<div className="container flex flex-col gap-8">
					{showNoEventsBox ? (
						<NoEventsBox {...noEventsBox} />
					) : (
						<>
							<div className="flex flex-col gap-8">
								{events.map((event, i) => (
									<EventCard key={i} {...event} />
								))}
							</div>
							{totalPages > 1 && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />}
						</>
					)}
				</div>
			</section>
		</>
	)
}
